import { getUpdateUserState, getUserDetailsState } from './../users.selectors';
import { ActivatedRoute } from '@angular/router';
import { SetDefaultData, FetchUserRequest } from './../users.actions';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Map, List } from 'immutable';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit, OnDestroy {

  public state: Map<string, any>;
  private state$: Subscription;
  public userId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) { }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('userDetails'))

    this.state$ = this.store.pipe(select(getUserDetailsState)).subscribe(state => {
      this.state = state;
    });

    this.store.dispatch<any>(new FetchUserRequest(this.userId, 'userDetails'))
  }

  sanitizeRoles(roles: List<Map<string, any>>) {
    return roles && roles.map((role: Map<string, any>) => role.get('title')).toJS().join(", ");
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }
}
